//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum ReviewKind {

  FromLandowner = 0,

  FromMember = 1,

}

export default ReviewKind;